
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class SgjTable extends Vue {
    //水果机
    table = {
        data: [],
        column: <any>[]
    }
    //水果机详情
    optTabledatafruit = [
        {
            key: 'path',
            title: '投注区',
            align: 'center',
            render: (h, params) => {
                return h('span', '投注金额')
            }
        },
        {
            key: 'rate',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_list['bar'])
                return h('span', str)
            },
            renderHeader: (h, params) => {
                return h('div', { style: { marginTop: '5px' }, domProps: { innerHTML: "<img style='width:35px' src=img/poker/fruit/bar.png>" } })
            }
        },
        {
            key: 'rate',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_list['seven'])
                return h('span', str)
            },
            renderHeader: (h, params) => {
                return h('div', { style: { marginTop: '5px' }, domProps: { innerHTML: "<img style='width:35px' src=img/poker/fruit/seven.png>" } })
            }
        },
        {
            key: 'rate',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_list['star'])
                return h('span', str)
            },
            renderHeader: (h, params) => {
                return h('div', { style: { marginTop: '5px' }, domProps: { innerHTML: "<img style='width:35px' src=img/poker/fruit/star.png>" } })
            }
        },
        {
            key: 'rate',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_list['melon'])
                return h('span', str)
            },
            renderHeader: (h, params) => {
                return h('div', { style: { marginTop: '5px' }, domProps: { innerHTML: "<img style='width:35px' src=img/poker/fruit/melon.png>" } })
            }
        },
        {
            key: 'rate',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_list['bell'])
                return h('span', str)
            },
            renderHeader: (h, params) => {
                return h('div', { style: { marginTop: '5px' }, domProps: { innerHTML: "<img style='width:35px' src=img/poker/fruit/bell.png>" } })
            }
        },
        {
            key: 'rate',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_list['lemon'])
                return h('span', str)
            },
            renderHeader: (h, params) => {
                return h('div', { style: { marginTop: '5px' }, domProps: { innerHTML: "<img style='width:35px' src=img/poker/fruit/lemon.png>" } })
            }
        },
        {
            key: 'rate',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_list['orange'])
                return h('span', str)
            },
            renderHeader: (h, params) => {
                return h('div', { style: { marginTop: '5px' }, domProps: { innerHTML: "<img style='width:35px' src=img/poker/fruit/orange.png>" } })
            }
        },
        {
            key: 'rate',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_list['apple'])
                return h('span', str)
            },
            renderHeader: (h, params) => {
                return h('div', { style: { marginTop: '5px' }, domProps: { innerHTML: "<img style='width:35px' src=img/poker/fruit/apple.png>" } })
            }
        }
    ]
    //水果机投注详情
    optTabledataSgjTZ = [
        {
            key: 'bill_no',
            align: 'center',
            title: '订单号',
            render: (h, params) => {
                return h('span', params.row.bill_no)
            }
        },
        {
            key: 'bet_list',
            align: 'center',
            title: '投注金额',
            render: (h, params) => {
                //opt_code==3支出，4收益
                if (params.row.opt_code == 4) {
                    return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail).bet_point))
                } else {
                    let obj = JSON.parse(params.row.opt_detail).bet_list || {}
                    let num = 0
                    for (let k in obj) {
                        num += obj[k]
                    }
                    return h('div', (this as any).getMoney(num))
                }
            }
        },
        {
            key: 'hit_point',
            align: 'center',
            title: '返奖金额',
            render: (h, params) => {
                if (params.row.opt_code == 4) {
                    return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail).hit_point))
                } else {
                    return h('span', '/')
                }
            }
        },
        {
            key: 'rate',
            align: 'center',
            title: '中奖列表',
            render: (h, params) => {
                if (params.row.opt_code == 4) {
                    let arr = JSON.parse(params.row.opt_detail).list || []
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: arr.map((x) => {
                                return "<img style='width:35px;' src=img/poker/fruit/" + x.path + '.png><p>倍数:' + x.rate + '<p>'
                            })
                        }
                    })
                } else {
                    return h('span', '/')
                }
            }
        }
    ]
    //水果机猜大小支出
    optTabledataSgjDXZC = [
        {
            key: 'bill_no',
            align: 'center',
            title: '订单号',
            render: (h, params) => {
                return h('span', params.row.bill_no)
            }
        },
        {
            key: 'bet_list',
            align: 'center',
            title: '投注金额',
            render: (h, params) => {
                return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail).point))
            }
        },
        {
            key: 'val',
            align: 'center',
            title: '押大小',
            render: (h, params) => {
                let str = '/'
                if (JSON.parse(params.row.opt_detail).val) {
                    str = JSON.parse(params.row.opt_detail).val == 2 ? '押大' : '押小' //2大、1小
                }
                return h('span', str)
            }
        }
    ]
    // 水果机猜大小收益
    optTabledataSgjDXSY = [
        {
            key: 'bill_no',
            align: 'center',
            title: '订单号',
            render: (h, params) => {
                return h('span', params.row.bill_no)
            }
        },
        {
            key: 'hit_point',
            align: 'center',
            title: '返奖金额',
            render: (h, params) => {
                return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail).hit_point))
            }
        },
        {
            key: 'ind',
            align: 'center',
            title: '中奖列表',
            render: (h, params) => {
                return h('div', JSON.parse(params.row.opt_detail).ind)
            }
        }
    ]
    getColumn() {
        if (JSON.parse(this.listdata[0].opt_detail).ind > 0 || JSON.parse(this.listdata[0].opt_detail).val > 0) {
            //opt_code==3支出，4收益
            this.table.column = this.listdata[0].opt_code == 3 ? this.optTabledataSgjDXZC : this.optTabledataSgjDXSY
        } else {
            this.table.column = this.optTabledataSgjTZ
        }
        return this.table.column
    }

    @Prop()
    listdata
}
